import { useGenericTestimonials } from "../hooks/useGenericTestimonials";

export const useProgramTestimonials = ({
  programId = null,
  currentBrand = "Planet"
} = {}) => {
  return useGenericTestimonials(programId, currentBrand);
};
